var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 255C197.916 255 255 197.916 255 127.5C255 57.0837 197.916 0 127.5 0C57.0837 0 0 57.0837 0 127.5C0 197.916 57.0837 255 127.5 255Z",
    fill: "#0160AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.16 166.32H64.96C63.87 166.32 63 165.44 63 164.35C63 164.29 63 164.23 63 164.17L68.58 106.48C68.68 105.48 69.52 104.71 70.53 104.71H123.79C124.78 104.71 125.61 105.45 125.74 106.43L128.5 128.5C128.61 129.58 127.83 130.54 126.76 130.66C125.71 130.77 124.76 130.03 124.61 128.99L122.06 108.64H72.31L67.11 162.4H88.15C108.43 162.4 120.04 150.54 132.33 138C146.67 123.36 161.43 108.19 191.06 108.96C192.14 108.99 193 109.89 192.97 110.97C192.97 112.03 192.09 112.89 191.03 112.88C191.01 112.88 190.98 112.88 190.96 112.88C163.08 112.18 148.88 126.7 135.13 140.75C122.24 153.9 110.07 166.33 88.14 166.33L88.16 166.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41 113.85C109.33 113.85 108.45 112.97 108.44 111.89C108.44 104.81 106.93 92.93 96.8 92.93C86.67 92.93 85.16 104.81 85.16 111.89C85.16 112.97 84.28 113.85 83.2 113.85C82.12 113.85 81.24 112.97 81.24 111.89C81.24 97.34 86.91 89 96.81 89C106.71 89 112.38 97.34 112.38 111.89C112.38 112.97 111.5 113.85 110.42 113.85H110.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.52 157.06C127.38 157.06 126.45 156.14 126.45 155C126.45 154.35 126.76 153.73 127.28 153.34C131.04 150.52 134.93 146.44 139.04 142.13C149.04 131.63 160.38 119.74 176.85 117.47C177.98 117.3 179.03 118.07 179.2 119.2C179.37 120.33 178.6 121.38 177.47 121.55C177.45 121.55 177.43 121.55 177.41 121.55C162.37 123.62 151.56 134.96 142.03 144.97C137.79 149.41 133.79 153.61 129.76 156.64C129.4 156.91 128.97 157.05 128.52 157.05V157.06Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumo);
export default __webpack_public_path__ + "static/media/consumo.349a194b479fe6c0ac779142c0a4ad03.svg";
export { ForwardRef as ReactComponent };